import { LeadFirstContact, LeadLeaveReason, LeadSource, LeadStatus } from 'entities/Lead';
import { TableFilterType } from 'features/TableFilter';
import { getFilterServerFormatDate } from 'shared/utils/helpers/getDateFormat';
import { ContractApplicability } from '../../model/types';

interface LeadListFilters {
  warehouseId?: string;
  leadStatuses?: LeadStatus[];
  squareFrom?: number;
  squareTo?: number;
  creationDateFrom?: string;
  creationDateTo?: string;
  firstContact?: LeadFirstContact;
  isApplicable?: boolean;
  leaveReason?: LeadLeaveReason;
  sources?: LeadSource[];
}

export const transformLeadsListFilters = ({
  selectedWarehouseId,
  leadStatuses,
  squareFrom,
  squareTo,
  creationDateFrom,
  creationDateTo,
  firstContact,
  isApplicable,
  leaveReason,
  sources,
}: TableFilterType): LeadListFilters => {
  return {
    warehouseId: selectedWarehouseId?.value || undefined,
    squareFrom: squareFrom?.value || undefined,
    squareTo: squareTo?.value || undefined,
    leadStatuses: leadStatuses?.value || undefined,
    firstContact: firstContact?.value || undefined,
    creationDateFrom: getFilterServerFormatDate(creationDateFrom?.value),
    creationDateTo: getFilterServerFormatDate(creationDateTo?.value),
    isApplicable: isApplicable?.value === undefined ? undefined : isApplicable?.value === ContractApplicability.APPLICABLE,
    leaveReason: leaveReason?.value || undefined,
    sources: sources?.value || undefined,
  };
};
